import { render, staticRenderFns } from "./RossettoVideo.vue?vue&type=template&id=277623ba&"
import script from "./RossettoVideo.vue?vue&type=script&lang=js&"
export * from "./RossettoVideo.vue?vue&type=script&lang=js&"
import style0 from "./RossettoVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports